import { useTranslation } from 'react-i18next';

import { EventJournalQueries } from '@entities/eventJournal/model/queries';
import { useCalendarQueries } from '@entities/сalendar/lib/useCalendarQueries';
import { useJournalEventsFiltersContext } from '@features/JournalEventsFilters/lib/useJournalEventsFiltersContext';
import { useNuqsQueryState } from '@shared/hooks';

export const useFilterTags = () => {
    const {
        authorsData,
        typesData,
        estimatesData,
        onAuthorClick,
        onTypeClick,
        onEstimateClick,
        onDateClick,
        onClearAllValues,
    } = useJournalEventsFiltersContext();
    const { t } = useTranslation();
    const { state: searchQueryValue, setState: setSearchQueryState } = useNuqsQueryState(
        EventJournalQueries.search
    );
    const { dateFromQueryValue, dateToQueryValue } = useCalendarQueries();
    const dateRangeQueryValue = `${dateFromQueryValue} ${
        dateToQueryValue ? `- ${dateToQueryValue}` : ''
    }`;

    const isClearValuesBtn =
        searchQueryValue?.length > 0 ||
        dateFromQueryValue ||
        dateToQueryValue ||
        authorsData.some((item) => item.isChecked) ||
        typesData.some((item) => item.isChecked) ||
        estimatesData.some((item) => item.isChecked);

    return {
        searchQueryValue,
        dateFromQueryValue,
        dateToQueryValue,
        isClearValuesBtn,
        dateRangeQueryValue,
        authorsData,
        typesData,
        estimatesData,
        onAuthorClick,
        onTypeClick,
        onEstimateClick,
        onDateClick,
        onClearAllValues,
        setSearchQueryState,
        t,
    };
};
